import React from "react";
import { ToastContent, ToastOptions, toast } from "react-toastify";

const getContent = (): JSX.Element => {
    return <button>TEst</button>
}

const showMesage = (message: string, isStatic?: boolean, isSuccess?: boolean): void => {

    const toastOptions: ToastOptions = {
        position: 'top-right',
        autoClose: isStatic ? false : 10000,
        closeOnClick: true,
        bodyStyle: {
            margin: '5px', whiteSpace: 'pre-line', fontSize: '14px',
        },
        delay: 0,
    };

    if (isSuccess) {
        toast.success(message, toastOptions);
    }
    else {
        toast.error(message, toastOptions);
    }
}

const showMesageAsContent = (content: JSX.Element, isStatic?: boolean, isSuccess?: boolean, closeAfterMileSeconds?: number): void => {

    const toastOptions: ToastOptions = {
        position: 'top-right',
        autoClose: isStatic ? false : closeAfterMileSeconds ? closeAfterMileSeconds : 10000,
        closeOnClick: true,
        bodyStyle: {
            margin: '5px', whiteSpace: 'pre-line', fontSize: '14px',
        },
        delay: 0,
    };

    if (isSuccess) {
        toast.success(content, toastOptions);
    }
    else {
        toast.error(content, toastOptions);
    }
}


const messageHelper = {
    showMesage,
    showMesageAsContent
}

export default messageHelper;
